<template>
  <div class="modal-mask">
    <div class="modal-form">
      <div class="modal-form__header">
        <p class="modal-form__name">Вход</p>
        <p class="modal-form__description">Личный кабинет</p>
      </div>
      <div class="modal-form__body">
        <div class="modal-form__input">
          <AppInput title="Логин"
                    :width="mediaBreakpoint !== 'desktop' ? '100%' : '400px'"
                    :value="authData.login"
                    required
                    :valid="validation.login"
                    @value-changed="setAuthLogin"
                    @got-focus="clearValidation('login')"
                    @keyup-enter="logIn"
          />
        </div>
        <div class="modal-form__input">
          <AppInput title="Пароль"
                    :width="mediaBreakpoint !== 'desktop' ? '100%' : '400px'"
                    :value="authData.password"
                    isPassword
                    required
                    :valid="validation.password"
                    @value-changed="setAuthPassword"
                    @got-focus="clearValidation('password')"
                    @keyup-enter="logIn"
          />
        </div>

        <div class="modal-form__button-wrap">
          <AppButton title="Вход" type="third" @click.native="logIn"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppInput from '../input/AppInput.vue'

export default {
  name: 'login-form',
  components: {
    AppInput,
    AppButton
  },
  computed: {
    authData () {
      return this.$store.getters.authData
    },
    validation () {
      return this.$store.getters.authData.validation
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    }
  },
  methods: {
    setAuthLogin (value) {
      this.$store.dispatch('setAuthLogin', value)
    },
    setAuthPassword (value) {
      this.$store.dispatch('setAuthPassword', value)
    },
    async logIn () {
      await this.$store.dispatch('logIn')
    },
    clearValidation (input) {
      this.$store.dispatch('loginFormClearValidation', input)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  background: #173F7D;
  background: url('/img/svg/background_02.svg'),
  linear-gradient(#173F7D 0%, #1170B8 100%);
  background-size: cover;
  padding-right: 20px;
  padding-left: 20px;
}

.modal-form {
  width: 100%;
  max-width: 500px;
  background-color: $color_second;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.25);

  &__header {
    padding: 25px 20px;
    background: url('/img/svg/background_02.svg') no-repeat;
    background-size: cover;
    display: flex;
    flex-flow: column;
    align-items: center;
    color: $font_color_alt;

    @media screen and (max-width: $tablet_start) {
      padding: 14px 20px;
    }
  }

  &__name {
    font-size: 30px;
    font-weight: bold;
    text-transform: uppercase;
  }

  &__body {
    background-color: $color_main;
    color: $font_color_main;
    padding: 35px 50px;

    @media screen and (max-width: $tablet_start) {
      padding: 30px 20px;
    }
  }

  &__input {
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
</style>
